<template>
	<div class="home-view--banner">
		<div class="opacity"></div>
		<div
			class="logo-header"
			v-if="companyData.logoCompany && companyData.logoCompany[0]">
			<img
				:src="companyData.logoCompany[0].url"
				:alt="companyData.logoCompany[0].title"
			/>
		</div>
		
		<btn-edit v-if="editable" class="top-responsive" :right="300" icon="modal" @edit-section="openModalModal"/>	
		<btn-edit v-if="editable" class="top-responsive" @edit-section="openModalSeo" icon="seo" :right="161" />
		<btn-edit v-if="editable" class="top-responsive" @edit-section="openModal" :right="91" />
		<btn-logoff v-if="editable" class="top-responsive" @logoff="logOff" :right="21"  />

		<div class="home-banner-sliders">
			<slider :options="options">
				<slideritem
					class="home-banner-slide"
					v-for="(slide, index) in banners"
					:style="`background-image: url(${slide.img})`"
					:key="index">
				</slideritem>
			</slider>
			<!-- <div
				class="home-banner-slide"
				v-for="(slide, index) in banners"
				:style="`background-image: url(${slide.img})`"
				:key="index">
				<div class="slide-content"></div>
			</div> -->
		</div>
		<div class="home-banner-networks">
			<a href="#" class="item-network">
				<simple-svg 
					:filepath="'/static/img/navbar-facebook-logo.svg'"
					:width="'9px'"
					:fill="'#fff'"
				/>
			</a>
			<a href="#" class="item-network">
				<simple-svg 
					:filepath="'/static/img/navbar-google-plus.svg'"
					:width="'17px'"
					:fill="'#fff'"
				/>
			</a>
			<a href="#" class="item-network">
				<simple-svg 
					:filepath="'/static/img/navbar-youtube.svg'"
					:width="'14px'"
					:fill="'#fff'"
				/>
			</a>
		</div>
		<edit-modal-banner
			v-if="open"
			:items="items"
			title="Banners"
			:url-image="urlImage"
			@add-image="addImage"
			@close-modal="closeModal"
			@remove-img="removeImage"
			@save="save"
			@send-image="getImage"
		/>
		<edit-modal-seo
			v-if="openSeo"
			@close-modal="closeModalSeo"
		/>
		<editModalModal v-if="openModalPromo"  @close-modal="closeModalModal"></editModalModal>
	</div>
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider';
import btnEdit from '@/components/commons/btn-edit';
import btnLogoff from '@/components/commons/btn-logoff';
import editModalBanner from '@/components/commons/edit-modal-banner';
import editModalSeo from '@/components/commons/edit-modal-seo';
import editModalModal from '@/components/commons/edit-modal-modal';

const components = {
	btnEdit,
	btnLogoff,
	editModalBanner,
	slider,
	slideritem,
	editModalSeo,
	editModalModal
};

const computed = {
	options() {
		return {
			pagination: false,
			loop: true,
			speed: 1000,
			autoplay: 6000,
		};
	},
};

const methods = {
	logOff() {
		localStorage.clear();
		location.href='/';
	},
	addImage() {
		this.items.push({ id: this.items.length + 1, img: this.urlImage });
		this.urlImage = '';
	},
	closeModal() {
		this.open = false;
		this.items = [];
		this.urlImage = '';
	},
	getImage(img) {
		this.urlImage = img;
	},
	openModal() {
		this.items = this.banners.map(banner => ({ ...banner }));
		this.open = true;
	},
	openModalSeo() {
		this.openSeo = true;
	},
	closeModalSeo(){
		this.openSeo = false;
	},
	removeImage(index) {
		this.items.splice(index, 1);
	},
	openModalModal() {
		this.openModalPromo = true;
	},
	closeModalModal() {
		this.openModalPromo = false;
	},	
	async save(body) {
		const newBody = {
			id: this.id,
			name: process.env.APP_NAME,
			flagActive: 1,
			tagId: 1,
			dataSections: {
				home: {
					description: '',
					flagSearch: false,
					images: body.map(b => b.img),
					placeholderSearch: '',
					subTitle: '',
					title: '',
				},
			},
		};
		try {
			await this.$http.put(`edit/pages/${this.id}`, newBody);
			this.showNotification('Los cambios han sido aplicados correctamente.');
			this.closeModal();
			this.$emit('banner-updated');
			setTimeout(() => {
				location.reload();
			}, 2000);
		} catch (err) {
			if (err.status === 500) {
				this.showError();
			}
		}
	},
};

const props = {
	banners: {
		default: () => [],
		type: Array,
	},
	companyData: {
		default: () => {},
		type: Object,
	},
	id: [Number, String],
	isMounted: {
		default: false,
		type: Boolean,
	},
};

const watch = {
	open(value) {
		this.onModal(value);
	},
};

function data() {
	return {
		items: [],
		open: false,
		urlImage: '',
		openSeo: false,
		openModalPromo: false,
	};
}

export default {
	name: 'banner',
	components,
	computed,
	data,
	methods,
	props,
	watch,
};
</script>

<style lang="scss" scoped>
	.home-view--banner {
		position: relative;
		padding-top: 49px;
	}

	.home-banner-slide {
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		min-height: 600px;
		min-height: calc(100vh - 49px);
		position: relative;
	}

	.slide-content {
		@include flex-center();
		bottom: 0;
		flex-direction: column;
		left: 0;
		position: absolute;
		right: 0;
		text-align: center;
		top: 0;
		z-index: 5;
	}

	.home-banner-networks {
		@include flex-center;
		bottom: 50px;
		opacity: 0;
		position: absolute;
		width: 100%;
		.item-network {
			margin-right: 24px;
		}
	}

	@media screen and (max-width: 1024px) {
		.home-banner-networks {
			opacity: 1;
		}
	}

	.opacity {
    @include linear-gradient(
      180deg,
      transparent,
      rgba(0, 29, 50, .1),
      rgba(0, 29, 50, .3),
      rgba(18, 20, 21, .7),
      rgba(18, 20, 21, .8)
    );
		bottom: 0;
		left: 0;
		position: absolute;
		right: 0;
		top: 0;
		z-index: 2;
	}

	.logo-header {
		bottom: 0px;
		height: 110px;
		left: 0px;
		margin: auto;
		position: absolute;
		right: 0px;
		top: 0px;
		width: 188px;
		z-index: 9;
	}

	.top-responsive {
		bottom: 15px;
		top: auto !important;

		@media (min-width: 964px) {
			bottom: auto;
			top: 57px !important;
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/home/banner.vue